module.exports = __webpack_public_path__ + "img/arrow.413c36b8.png";